import React from 'react';
import { useShallow } from 'zustand/react/shallow';

import { PaidBreakExceptionAction } from '#/shared/components/PaidBreakException';
import { useAnalytics } from '#/shared/hooks/useAnalytics';
import { useFeatureFlag } from '#/shared/hooks/useFeatureFlag';
import { usePaidBreakExceptionStore } from '#/shared/stores/paidBreakExceptionStore';
import { useTimesheetStore } from '#/shared/stores/timesheetStore';
import type { PaidBreakRequestStatus } from '#/shared/types/PaidBreakRequest';

import { AcceptAllModal } from './AcceptAllModal';
import { RejectAllModal } from './RejectAllModal';

export function PaidBreakExceptionsActions() {
  const { track } = useAnalytics();
  const timesheetId = useTimesheetStore(state => state.timesheet?.timesheetId ?? '');

  const { isEnabled: paidBreakExceptionsIsEnabled } = useFeatureFlag('PPL-2119-paid-break-exception');
  const totalBreakExceptionsDuration = usePaidBreakExceptionStore(useShallow(s => s.getTotalExceptionsBreak()));
  const isAllBreakExceptionsRejected = usePaidBreakExceptionStore(useShallow(s => s.hasAllRejected()));
  const isAllBreakExceptionsAccepted = usePaidBreakExceptionStore(useShallow(s => s.hasAllAccepted()));
  const breakExceptionActionsStatus: PaidBreakRequestStatus = isAllBreakExceptionsAccepted
    ? 'accepted'
    : isAllBreakExceptionsRejected
      ? 'rejected'
      : 'pending';
  const isBreakExceptionActionsVisible = paidBreakExceptionsIsEnabled && !totalBreakExceptionsDuration.isZero();

  const [isAcceptAllModalOpen, setIsAcceptAllModalOpen] = React.useState(false);
  const handleAcceptAllPress = () => {
    track('Online approval web - Press Accept All', {
      Timesheet_ID: timesheetId,
    });
    setIsAcceptAllModalOpen(true);
  };

  const [isRejectAllModalOpen, setIsRejectAllModalOpen] = React.useState(false);
  const handleRejectAllPress = () => {
    track('Online approval web - Press Reject All', {
      Timesheet_ID: timesheetId,
    });
    setIsRejectAllModalOpen(true);
  };

  if (isBreakExceptionActionsVisible) {
    return (
      <>
        <PaidBreakExceptionAction
          breakDuration={totalBreakExceptionsDuration.toString()}
          variant="summary"
          status={breakExceptionActionsStatus}
          onAccept={handleAcceptAllPress}
          onReject={handleRejectAllPress}
        />
        <AcceptAllModal isOpen={isAcceptAllModalOpen} onClose={() => setIsAcceptAllModalOpen(false)} />
        <RejectAllModal isOpen={isRejectAllModalOpen} onClose={() => setIsRejectAllModalOpen(false)} />
      </>
    );
  }

  return null;
}
